var ISDEV = false
var BASE_URL = 'https://api.xituan.cn/api'
var EXPORT_PHONE = ['17352837649', '13699199469', '18673079094', '17373270235', '15818532844'] // 可以有导出功能的用户（暂时废弃）
var SERVICE = 'pro' // test-测试环境 pro-正式环境
var MAP_KEY = '5TKBZ-4LGCZ-6OGXN-7VDJF-DMLVF-JPBVB' // 高德地图key

var HOSTNAME = window?.location?.hostname || ''
if (HOSTNAME == 's.xituan.cn') {
  BASE_URL = 'https://api.xituan.cn/api' // 生产环境
  SERVICE = 'pro'
} else if (HOSTNAME == 'tests.xituan.cn') {
  BASE_URL = 'https://testapi.xituan.cn/api' // 测试环境
  SERVICE = 'test'
} else if (HOSTNAME == 'localhost') {
  BASE_URL = 'https://testapi.xituan.cn/api' // 测试环境
  SERVICE = 'test'
}

if (process.env.NODE_ENV == 'development') {
  // 开发环境-dev
  ISDEV = true
  BASE_URL = '/api'
}

export default {
  BASE_URL,
  ISDEV,
  SERVICE,
  EXPORT_PHONE,
  MAP_KEY
}
